module.exports = __webpack_public_path__ + "img/04-B01.1b4945d8.png";